export default function CustomerBankAccount() {

  return (
      <p>حساب های بانکی مشتری</p>
  );
};